"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerraformingControlStation = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Tags_1 = require("../Tags");
var Options_1 = require("../Options");
var TerraformingControlStation = (function (_super) {
    __extends(TerraformingControlStation, _super);
    function TerraformingControlStation() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.TERRAFORMING_CONTROL_STATION,
            cost: 18,
            tags: [Tags_1.Tags.VENUS, Tags_1.Tags.MARS, Tags_1.Tags.SPACE],
            tr: { tr: 2 },
            metadata: {
                cardNumber: 'Pf12',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When you play a Venus or Mars tag, pay 2MC less.', function (eb) {
                        eb.venus(1, { played: Options_1.played }).slash().mars(1, { played: Options_1.played }).startEffect.megacredits(-2);
                    });
                    b.br.tr(2);
                }),
                description: 'Raise your TR 2 steps.',
            },
        }) || this;
    }
    TerraformingControlStation.prototype.getCardDiscount = function (_player, card) {
        if (card.tags.includes(Tags_1.Tags.VENUS) || card.tags.includes(Tags_1.Tags.MARS)) {
            return 2;
        }
        return 0;
    };
    TerraformingControlStation.prototype.play = function (player) {
        player.increaseTerraformRatingSteps(2);
        return undefined;
    };
    return TerraformingControlStation;
}(Card_1.Card));
exports.TerraformingControlStation = TerraformingControlStation;
